import { ApiClient } from "#/shared/api/client";

class InstamedApi extends ApiClient {
  constructor() {
    super({});
  }

  capture(url, paymentInfo) {
    return this.post(url, paymentInfo);
  }
}

export function createInstamedApi() {
  const api = new InstamedApi();

  return {
    capture: (url, paymentInfo) => api.capture(url, paymentInfo),
  };
}
